import * as React from 'react';
import { SVGProps } from 'react';

const SvgFilterOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.104 3.556A1 1 0 0 1 4 3h16a1 1 0 0 1 .796 1.606l-6.196 8.14V20a1 1 0 0 1-1.486.874l-3.2-1.778a1 1 0 0 1-.514-.874v-5.476l-6.196-8.14a1 1 0 0 1-.1-1.05ZM6.018 5l5.178 6.803a1 1 0 0 1 .204.606v5.225l1.2.666V12.41a1 1 0 0 1 .204-.606L17.982 5H6.018Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgFilterOutlined;
